var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "management-sidebar-item" },
    [
      _c(
        "v-layout",
        {
          staticClass: "management-sidebar-title",
          class: { activeTab: _vm.activeTab },
          attrs: { row: "", "align-center": "" },
          on: { click: _vm.toggleMenuItem }
        },
        [
          _vm._t("icon"),
          _vm._v(" "),
          _c("span", { staticClass: "sidebar-title" }, [
            _vm._v(_vm._s(_vm.item.name))
          ])
        ],
        2
      ),
      _vm._v(" "),
      _vm._t("subMenu")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b36dc7f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b36dc7f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Management/Sidebar/SidebarMenuItem.vue
// module id = null
// module chunks = 